import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker'
import { MatSnackBar } from '@angular/material/snack-bar';


  @Injectable({   
    providedIn: 'root'
  })
  @Injectable()
  export class UpdateService {
  
    constructor(
      private updates   : SwUpdate,
      private _snackBar : MatSnackBar
    ) {
        this.checkForUpdate();
      }

    public checkForUpdate () : void {

      if (!this.updates.isEnabled) {
        console.debug("Service Worker is not enabled in this context and update will not work");
        return;
      }

      // SEE https://angular.io/guide/service-worker-communications#version-updates        
      this.updates.versionUpdates.subscribe(evt => {        
        switch (evt.type) {
          case 'VERSION_DETECTED':
            console.debug(`Downloading new app version: ${evt.version.hash}`);
            break;

          case 'VERSION_READY':
            console.debug(`Current app version: ${evt.currentVersion.hash}`);
            console.debug(`New app version ready for use: ${evt.latestVersion.hash}`);

            if (window && window.location && window.location.reload) {

              if (("" + window.location).indexOf('autoUpdate=true') >= 0) {
                console.log("Reloading to take update");                
                window.location.reload();                
              }
              else {
                this._snackBar.dismiss();
                this._snackBar.open('An Update is Available', 'Update Now', {
                  duration: 60000,
                  horizontalPosition: 'center',
                  verticalPosition: 'top',
                  politeness: 'assertive'
                }).onAction().subscribe(() => {
                  window.location.reload();
                });
              }
            }

            break;

          case 'VERSION_INSTALLATION_FAILED':
            console.debug(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
            break;
        }
      });

      // TODO How often is this going to check?
      // SEE https://angular.io/guide/service-worker-communications#checking-for-updates
      try {
        this.updates.checkForUpdate().then((result) => {
          console.debug(result ? 'A new version is available.' : 'Already on the latest version.');
        }).catch((error) => { 
          console.error('Failed to check for updates:', error); 
        }).finally(() => {           
        });

      } catch (error) {
        console.error('Failed to check for updates:', error); 
      }

    }
  }
